import { Avatar, AvatarGroup, Stack, Typography } from '@mui/material';
import { deepOrange } from '@mui/material/colors';
const BookAuthorsDetails = ({ authorArrays, isEdit = false }) => {
  if (authorArrays.length === 0) return null;

  return (
    <Stack direction="row" gap={2} sx={{ alignItems: 'center', mb: '1rem' }}>
      <AvatarGroup>
        {authorArrays.map((author) => {
          let image = author.image;
          if (!image) {
            return (
              <Avatar key={author._id} sx={{ bgcolor: deepOrange[500] }}>
                {author.full_name.charAt(0).toUpperCase()}
              </Avatar>
            );
          }
          if (!image.includes('http') || !image.includes('https')) {
            const Image_Url = process.env.REACT_APP_API_IMAGEURL;
            image = Image_Url + image;
          }
          return <Avatar key={author._id} alt={author.full_name} src={image} />;
        })}
      </AvatarGroup>
      <Stack direction="row">
        <Typography variant="subtitle2">{authorArrays.map((author) => author.full_name).join(', ')}</Typography>
      </Stack>
    </Stack>
  );
};

export default BookAuthorsDetails;
